import { Vw_Stoklar } from './../../models/Vw_Stoklar';
import { Injectable } from "@angular/core";
import { Database } from './../database';
import 'rxjs/add/operator/map';
@Injectable()
export class BllViewStoklar extends Database{
    eklenecek_stokkartlari=[];
    guncellencek_stokkartlari=[];

    constructor(){
        super("Vw_Stoklar");
    }
    FiyatlariGuncelle(stok: Vw_Stoklar) {
        return new Promise((res, err) => {
          this.execRawQueryWithParams("update Vw_Stoklar set Price1 = ? where ID = ?", [stok.Price1, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set Price2 = ? where ID = ?", [stok.Price2, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set Price3 = ? where ID = ?", [stok.Price3, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set Price4 = ? where ID = ?", [stok.Price4, stok.ID]).then(a => {
            res(a);
          });
    
        })
      }
      ResimYoluGuncelle(stok)
      {
        return new Promise((res, err) => {
          this.execRawQueryWithParams("update Vw_Stoklar set Image1 = ? where ID = ?", [stok.Image1, stok.ID]).then(a => {
            res(a);
          });
        });
      }
      Duzenle(stok)
      {
        return new Promise((res, err) => {
          this.execRawQueryWithParams("update Vw_Stoklar set StokAdi = ? where ID = ?", [stok.StokAdi, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set Barcode1 = ? where ID = ?", [stok.Barcode1, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set Barcode2 = ? where ID = ?", [stok.Barcode2, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set Price1 = ? where ID = ?", [stok.Price1, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set Price2 = ? where ID = ?", [stok.Price2, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set Price3 = ? where ID = ?", [stok.Price3, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set Price4 = ? where ID = ?", [stok.Price4, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set Vat = ? where ID = ?", [stok.Vat, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set BirimId = ? where ID = ?", [stok.BirimId, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set KategoriID = ? where ID = ?", [stok.KategoriID, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set MarkId = ? where ID = ?", [stok.MarkId, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set VatGrupId = ? where ID = ?", [stok.VatGrupId, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set UlkeID = ? where ID = ?", [stok.UlkeID, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set PLU = ? where ID = ?", [stok.PLU, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set VaryantliMi = ? where ID = ?", [stok.ParentAktif, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set DolarFiyat = ? where ID = ?", [stok.DolarFiyat, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set DovizTipAdi = ? where ID = ?", [stok.DovizTipAdi, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set DovizTipi = ? where ID = ?", [stok.DovizTipi, stok.ID]).then(a => {
            res(a);
          });
          this.execRawQueryWithParams("update Vw_Stoklar set DovizSimge = ? where ID = ?", [stok.DovizSimge, stok.ID]).then(a => {
            res(a);
          });
         
        });
      }
      StokKartiEkle(GelenKart) {
        return new Promise((resolve, reject) => {
          var kart = new Vw_Stoklar();
          kart.ID = GelenKart.ID;
          kart.Kodu = GelenKart.Kodu;
          kart.StokAdi = GelenKart.StokAdi;
          kart.Barcode1 = GelenKart.Barcode1;
          kart.Barcode2 = GelenKart.Barcode2;
          kart.Vat = GelenKart.Vat;
          kart.KategoriID = GelenKart.KategoriID;
          kart.MarkId = GelenKart.MarkId;
          kart.VatGrupId = GelenKart.VatGrupId;
          kart.Price1 = GelenKart.Price1;
          kart.Price2 = GelenKart.Price2;
          kart.Price3 = GelenKart.Price3;
          kart.Price4 = GelenKart.Price4;
          kart.Status = GelenKart.Status;
          kart.WebStatus = GelenKart.WebStatus;
          kart.BirimId = GelenKart.BirimId;
          kart.Image1 = GelenKart.Image1;
          kart.Image2 = GelenKart.Image2;
          kart.IsTerazi = GelenKart.IsTerazi;
          kart.PLU = GelenKart.PLU;
          kart.FiyatDegisimTarihi = GelenKart.FiyatDegisimTarihi;
          kart.MaximumSeviye = GelenKart.MaximumSeviye;
          kart.MinumumSeviye = GelenKart.MinumumSeviye;
          kart.Hit = GelenKart.Hit;
          kart.EkranSiraNo = GelenKart.EkranSiraNo;
          kart.Giren = GelenKart.Giren;
          kart.Cikan = GelenKart.Cikan;
          kart.Kalan = GelenKart.Kalan;
          kart.KategoriAdi = GelenKart.KategoriAdi;
          kart.BirimAdi = GelenKart.BirimAdi;
          kart.MarkaAdi = GelenKart.MarkaAdi;
          kart.SatinAlmaTarihi = GelenKart.SatinAlmaTarihi;
          kart.SatisTarihi=GelenKart.SatisTarihi;
          kart.SatisGecenGun=GelenKart.SatisGecenGun;
          kart.Entegrasyon=GelenKart.Entegrasyon;
          kart.YerliMi=GelenKart.YerliMi;
          kart.UlkeAdi=GelenKart.UlkeAdi;
          kart.ParentAktif=GelenKart.ParentAktif;
          this.add(kart).then(a => {
            resolve(a);
          }).catch(x => {
            reject(x);
          })
        });
      }
}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-ViewStoklar.ts